import type { HandlingUnitType } from "@freightsimple/generated-dashboard-openapi-client/models/HandlingUnitType";
import { handlingUnitTypes } from "@/Data/handlingUnitTypes";

export function getHandlingUnitTypeInfo(handlingUnitType: HandlingUnitType) {
  const item = handlingUnitTypes.find((t) => t.type === handlingUnitType);

  if (item === undefined) {
    throw new Error(
      `Missing handling unit type ${handlingUnitType.toString()}`,
    );
  }

  return item;
}
